import { useMemo } from "react";
import { Tooltip } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import styled from "styled-components";

import { combineClassNames } from "@utils/appUtils";

import { InputErrorIcon } from "@components/SVGs";

const StyledTooltip = styled(Tooltip)`
  padding-left: ${({ type }) => (type === "error" ? "0 !important" : "auto")};

  .error {
    svg {
      padding-right: 5px !important;
      path {
        fill: white !important;
      }
    }
  }

  .tooltip-inner {
    background-color: ${({ type }) => (type === "error" ? "var(--du-color-red)" : "var(--du-color-black_85)")};
    text-align: left;
    font-size: 12px;
    font-family: "NotoSans", sans-serif;
    color: var(--du-color-white);
    white-space: pre-line;

    svg {
      margin-right: ${({ type }) => (type === "error" ? "5px" : "0")};
      margin-bottom: ${({ type }) => (type === "error" ? "2px" : "0")};

      path {
        fill: var(--du-color-white) !important;
        stroke-width: ${({ type }) => (type === "error" ? "1.5" : "inherit")};
      }
    }
  }

  .tooltip-arrow::before {
    border-top-color: ${({ type }) =>
      type === "error" ? "var(--du-color-red)" : "var(--du-color-black_85)"} !important;
  }
`;

const StyledOverlayTrigger = styled(OverlayTrigger)`
  border-radius: 2px;
  text-align: left;
`;

const CustomTooltip = ({ text, children, placement = "top", type, className }) => {
  const isError = type === "error";
  const hasText = Boolean(text);

  const tooltipContent = useMemo(() => {
    if (!hasText) return null;

    return (
      <StyledTooltip id='tooltip' type={type} className={combineClassNames(isError && "error", className)}>
        {isError && <InputErrorIcon />}
        {text}
      </StyledTooltip>
    );
  }, [text, type, className, isError, hasText]);

  const overlayProps = useMemo(
    () => ({
      placement: isError ? "top-start" : placement,
      overlay: tooltipContent,
      ...(isError && { show: hasText, className: "width-auto" }),
    }),
    [isError, placement, tooltipContent, hasText],
  );

  if (!hasText) {
    return children;
  }

  return <StyledOverlayTrigger {...overlayProps}>{children}</StyledOverlayTrigger>;
};

export default CustomTooltip;
